import {
    type ShareAnnouncementOnInstagramResponseType,
    type ShareAnnouncementOnInstagramRequestType
} from "./type";
import {
    request
} from "../request";

const ShareAnnouncementOnInstagram = async (params: ShareAnnouncementOnInstagramRequestType): Promise<ShareAnnouncementOnInstagramResponseType> => {
    return await request<ShareAnnouncementOnInstagramResponseType>("/announcement/shareAnnouncementOnInstagram", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default ShareAnnouncementOnInstagram;
